import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const API_BASE = `${REACT_APP_API_URL}api/dashboard/admin/breakfast-config`;

export const getBreakfastConfigurations = async (params) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
};

export const getProperties = async () => {
    const response = await axios.get(`${API_BASE}/properties`);
    return response.data;
};

export const getRoomTypes = async (propertyId) => {
    const url = propertyId
        ? `${API_BASE}/room-types/${propertyId}`
        : `${API_BASE}/room-types`;

    const response = await axios.get(url);
    return response.data;
};

export const createBreakfastConfiguration = async (payload) => {
    const response = await axios.post(API_BASE, payload);
    return response.data;
};

export const updateBreakfastConfiguration = async (id, payload) => {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
};

export const deleteBreakfastConfiguration = async (id, payload) => {
    const response = await axios.delete(`${API_BASE}/${id}`, {
        data: payload,
    });

    return response.data;
};